import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UICheckbox from 'UIComponents/input/UICheckbox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { List as ImmutableList } from 'immutable';
import ClassicEnrollmentFilterViewer from 'automation-ui-canvas/components/enrollment/ClassicEnrollmentFilterViewer';
import { StyledCriteraBorder } from 'automation-ui-enrollment/components/eventEnrollment/steps/EventEnrollmentReview';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import { useState } from 'react';
import { getPerformanceUrl } from 'automation-ui-canvas/utils/urls';
import GoalEditModal from 'automation-ui-management/components/goals/GoalEditModal';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { ILS_GOALS_MIGRATION } from 'automation-ui-canvas/constants/Gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GoalListControl = ({
  classicEnrollmentSettings,
  goalFilters,
  readOnly,
  flow,
  onChange
}) => {
  const goalCriteria = (classicEnrollmentSettings === null || classicEnrollmentSettings === void 0 ? void 0 : classicEnrollmentSettings.goalCriteria) || ImmutableList();
  const [isGoalModalOpen, setIsGoalModalOpen] = useState(false);
  const [isEditingGoalCriteriaILS, setIsEditingGoalCriteriaILS] = useState(!!(goalFilters !== null && goalFilters !== void 0 && goalFilters.value));
  const isUngatedForIlsGoals = useIsUngated(ILS_GOALS_MIGRATION);
  const clsGoalCriteria = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      "data-test-id": "contact-goals-root"
    }), /*#__PURE__*/_jsx(UICheckbox, {
      "data-test-id": "contact-goals-create-button",
      size: "small",
      readOnly: readOnly,
      checked: goalCriteria && goalCriteria.size > 0,
      onChange: ({
        target: {
          checked
        }
      }) => {
        if (!checked) {
          onChange({
            classicEnrollmentSettings: classicEnrollmentSettings === null || classicEnrollmentSettings === void 0 ? void 0 : classicEnrollmentSettings.set('goalCriteria', ImmutableList([]))
          });
        } else {
          setIsGoalModalOpen(true);
        }
      },
      description: /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.enrollmentNotificationSetting.classicUnenrollment.goalHelp"
        })
      }),
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "settingsV2.enrollmentNotificationSetting.classicUnenrollment.goal_cob",
        objectTypeId: flow.objectTypeId
      })
    }), goalCriteria && goalCriteria.size > 0 && /*#__PURE__*/_jsx("div", {
      className: "m-all-3",
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ClassicEnrollmentFilterViewer, {
          filters: goalCriteria,
          filterType: "enrollmentNode",
          showCriteriaTitle: false
        }), !readOnly && /*#__PURE__*/_jsx(Button, {
          "data-test-id": "contact-goals-edit-button",
          marginBlock: "300",
          use: "tertiary-light",
          size: "small",
          onClick: () => setIsGoalModalOpen(true),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "settingsV2.enrollmentNotificationSetting.classicUnenrollment.editGoal"
          })
        })]
      })
    })]
  });
  const ilsGoalCriteria = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UICheckbox, {
      size: "small",
      readOnly: readOnly,
      checked: isEditingGoalCriteriaILS,
      onChange: ({
        target: {
          checked
        }
      }) => {
        setIsEditingGoalCriteriaILS(checked);
        if (!checked) {
          onChange({
            goalFilters: {
              value: null
            }
          });
        }
      },
      description: /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.enrollmentNotificationSetting.classicUnenrollment.goalHelp"
        })
      }),
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "settingsV2.enrollmentNotificationSetting.classicUnenrollment.goal_cob",
        objectTypeId: flow.objectTypeId
      })
    }), isEditingGoalCriteriaILS && /*#__PURE__*/_jsx("div", {
      className: "p-all-3",
      children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
        WrapperComponent: StyledCriteraBorder,
        headerNode: null,
        objectTypeId: flow.objectTypeId,
        readOnly: !!readOnly,
        value: goalFilters === null || goalFilters === void 0 ? void 0 : goalFilters.value,
        onChange: newFilters => {
          onChange({
            goalFilters: {
              value: newFilters
            }
          });
        },
        openInEditMode: false
      })
    })]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isGoalModalOpen && /*#__PURE__*/_jsx(GoalEditModal, {
      redirect: () => {
        window.open(getPerformanceUrl({
          flowId: flow.flowId
        }), '_blank');
      },
      goalCriteria: goalCriteria,
      onConfirm: response => {
        onChange({
          classicEnrollmentSettings: classicEnrollmentSettings === null || classicEnrollmentSettings === void 0 ? void 0 : classicEnrollmentSettings.set('goalCriteria',
          //@ts-expect-error bad goal types
          response.goalCriteria)
        });
        setIsGoalModalOpen(false);
      },
      onReject: () => setIsGoalModalOpen(false),
      readOnly: readOnly
    }), isUngatedForIlsGoals ? ilsGoalCriteria : clsGoalCriteria]
  });
};
export default GoalListControl;